import { v4 as UUIDv4 } from 'uuid'

/**
 * Creates a new, unique event uuid
 * @returns the uuid
 */
const createEventId = () => UUIDv4()

export default createEventId
